import { useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/hooks/useAuth';
import { BranchSelector } from '../components/BranchSelector';
import { LanguageToggle } from '../../locale/components/LanguageToggle';
import layoutStyles from '../../auth/components/AuthLayout.module.css';
import primitives from '../../../styles/primitives.module.css';

export const BranchSelectorPage = ({
  token,
  t,
  locale,
  onLocaleChange,
  onBranchSwitch,
  needsBranchSelection,
  branchesInitialized,
}) => {
  const navigate = useNavigate();
  const { requiresPasswordRenewal, isChecking } = useAuth();

  const handleSelect = useCallback(
    async (branchId) => {
      await onBranchSwitch(branchId);
      navigate('/dashboard', { replace: true });
    },
    [navigate, onBranchSwitch],
  );

  if (isChecking) {
    return null;
  }

  if (requiresPasswordRenewal) {
    return <Navigate to="/renew-password" replace />;
  }

  if (!branchesInitialized) {
    return <Navigate to="/branch-initialization" replace />;
  }

  if (!needsBranchSelection) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className={layoutStyles.shell}>
      <main className={layoutStyles.panel}>
        <header className={layoutStyles.header}>
          <div className={layoutStyles.intro}>
            <p className={primitives.eyebrow}>{t('appName')}</p>
            <h1>{t('branchSelectorTitle')}</h1>
            <p className={primitives.subtitle}>{t('branchSelectorSubtitle')}</p>
          </div>
        </header>

        <BranchSelector token={token} t={t} variant="page" onSelect={handleSelect} />

        <div className={layoutStyles.footer}>
          <LanguageToggle locale={locale} onChange={onLocaleChange} />
        </div>
      </main>
    </div>
  );
};
